import { axiosDelete, axiosGet, axiosPost } from "../axios/config";

const endpoint = "/api/v2/dashboard-shares";

export const createDashboardShare = (data) => axiosPost(endpoint, data);
export const getDashboardShares = (data) => axiosGet(endpoint, data);
export const resendDashboardShare = (id, data) => axiosPost(`${endpoint}/${id}/resend`, data);
export const revokeDashboardShare = (id, data) => axiosDelete(`${endpoint}/${id}`, { data });

export const consumeOneTimeDashboardAccess = (shareId) =>
	axiosPost("/api/v2/share-dashboard/consume-one-time-access", { share_id: shareId });
